export default {
  SET_LOCALE: '@MYYOLA/I18N/SET_LOCALE',
};
